import React, { useEffect, useState } from 'react';
import './Header.css'
import './Footer.css'
import { useMyContext } from "./MyProvider";
import Policies from './Policies';
import Disclaimer from './Disclaimer';
import nicLogo from '../images/nicLogo.png';
import { red } from '@mui/material/colors';

const centerDivStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
const Footer = () => {
  const { lang } = useMyContext();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL_HEADER}/demo/getFooter/${lang}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PATCH"
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setData(data[0]);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);

  const renderModals = () => (
    <>
      {showPolicyModal && (
        <div className="policy-modal-overlay">
          <div className="policy-modal-content">
            <button className="close-modal-btn" onClick={() => setShowPolicyModal(false)}>&times;</button>
            <Policies />
          </div>
        </div>
      )}
      {showDisclaimerModal && (
        <div className="policy-modal-overlay">
          <div className="policy-modal-content">
            <button className="close-modal-btn" onClick={() => setShowDisclaimerModal(false)}>&times;</button>
            <Disclaimer />
          </div>
        </div>
      )}
    </>
  );

  const policyLink = (
    <div style={centerDivStyle} id="footer_five">
      <div style={centerDivStyle}>
        <span
          style={{ color: '#ff9900', fontWeight: 'bolder', cursor: 'pointer', margin: '0 10px' }}
          onClick={() => setShowPolicyModal(true)}
        >
          {/* {data?.polic || "Website Policies"} */}



        </span>
      </div>
    </div>
  );

  const disclaimerLink = (
    <div style={centerDivStyle} id="footer_second">
      <div style={centerDivStyle}>
        <span
          style={{ color: '#ff9900', fontWeight: 'bolder', cursor: 'pointer', margin: '0 10px' }}
          onClick={() => setShowDisclaimerModal(true)}
        >
          {data?.disclaimer || "Disclaimer"}
        </span>
      </div>
    </div>
  );

  const footerCommonContent = (isDataLoaded = true) => (
    <div id="footer_wrapper">
      {/* {disclaimerLink} */}
      {/* {policyLink} */}


      {/* <div style={centerDivStyle} id="footer_first">
        <div style={centerDivStyle}>
          <p>
            {isDataLoaded ? data?.designed : ""} &nbsp;
            <a style={{ color: '#ff9900', fontWeight: 'bolder' }} target="_blank" href="http://jkfcsca.gov.in/">
              {isDataLoaded ? data?.dept : ""}
            </a>
            , &nbsp;{isDataLoaded ? data?.state_name : ""}
          </p>
        </div>
      </div> */}


      <div style={{ display: "flex", justifyContent:"center", alignItems: 'center'}}>
          <p style={{ color: 'white',  fontSize:"17px", fontWeight: 'bolder'}}>
            Designed & Developed for Department of Public Distribution System, Govt of India
          </p>
          <div>
        <img style={{ height: '30px', marginLeft: "400%" }}
            src={nicLogo} alt="NIC Logo"
        />
      </div>
      </div>
      
    </div>
  );

  if (loading || error) {
    return (
      <div className="wrapper row4">
        <div id="copyright" className="clear">
          {footerCommonContent(false)}
        </div>
        {renderModals()}
      </div>
    );
  }

  return (
    <div className="wrapper row4" >
      <div id="copyright" className="clear">
        {footerCommonContent(true)}
      </div>
      {renderModals()}
    </div>
  );
};

export default Footer;
